import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => (
  <SvgIcon>
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 11.0812C1 10.4867 1.26444 9.92306 1.7216 9.54309L10.7216 2.06257C11.4626 1.44667 12.5374 1.44667 13.2784 2.06257L22.2784 9.54309C22.7356 9.92306 23 10.4867 23 11.0812V21C23 22.1046 22.1046 23 21 23H3C1.89543 23 1 22.1046 1 21V11.0812Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12 11V16.6569"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.17157 13.8284H14.8284"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
